// 0.72 (texto 11a, Parte A): o FIM de todo caminho de "voltar" é o My Planner, no dia de hoje.
// Usado pela raiz de cada aba (aba/[id], Ajustes, Anotações, Abas, Mensagens) e como proteção geral:
// se o "voltar" de uma tela falhar, o app cai aqui em vez de mostrar uma tela vazia.
import { router } from 'expo-router';

const ouvintes = new Set<() => void>();

/** O My Planner escuta para voltar ao dia de hoje quando alguém pede "voltar ao My Planner". */
export function ouvirVoltarAoPlanner(fn: () => void) {
  ouvintes.add(fn);
  return () => { ouvintes.delete(fn); };
}

/** Vai para o My Planner (aba "index"), no dia de hoje. Nunca lança erro. */
export function voltarAoMyPlanner() {
  try { router.navigate('/'); } catch { /* sem navegação montada: nada a fazer */ }
  ouvintes.forEach(f => { try { f(); } catch { /* ignora */ } });
}

// texto 12: no Android, o "voltar" do sistema na raiz de uma aba volta ao My Planner pelo próprio navegador das abas
// (backBehavior="initialRoute"). A barra das abas marca a hora desse "voltar" e o My Planner, ao ganhar o foco logo
// depois, volta para o dia de hoje (igual ao gesto do iPhone).
let voltouEm = 0;
/** Marca que o "voltar" do Android saiu de outra aba rumo ao My Planner. */
export function marcarVoltarAndroid() { voltouEm = Date.now(); }
/** O My Planner acabou de ganhar o foco pelo "voltar" do Android (e limpa a marca). */
export function tomarVoltarAndroid() {
  const ok = Date.now() - voltouEm < 1000;
  voltouEm = 0;
  return ok;
}
